export default __webpack_public_path__ + "static/smellsLikeGrape-045d5a5bbdc85c548363e0b8d1057ac0.png";